var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-videos row"},_vm._l((_vm.videos),function(video,index){return _c('div',{key:index,staticClass:"col-lg-6 py-2"},[_c('video-player',{attrs:{"lesson":video,"id":("video-player-" + index)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }